import React from 'react';
import get from 'lodash/get';
import chunk from 'lodash/chunk';
import {FormattedMessage} from 'react-intl';
import {Grid, Segment, Header} from 'semantic-ui-react';
import Config from 'Config';

const UnlockedBadge = props => (
  <div className='badge-unlocked'>
    <img src={`${Config.CONTENT_IMAGE_BASE_URL}/${props.imageId}`} />
  </div>
);

const LockedBadge = props => (
  <Segment circular={true} className='badge-locked'>
    <div className='rewards'>
      {props.reward}
    </div>
    <div className='points'>
      <FormattedMessage id='userManagement.userDetail.panes.badges.points' />
    </div>
    <div className='progress'>
      {props.userProgress} / {props.completionGoal}
    </div>
  </Segment>
);

const BadgeFooter = props => (
  <Header className='badge-footer'>
    <FormattedMessage id={`userManagement.userDetail.panes.badges.badge.${props.id}.title`} />
    <Header.Subheader>
      <FormattedMessage
        id={`userManagement.userDetail.panes.badges.badge.${props.id}.desc.${props.unlocked ? 'unlocked' : 'locked'}`}
        defaultMessage={props.description} />
    </Header.Subheader>
  </Header>
);

const UserBadgesPage = props => {
  const COLUMNS = 4;
  const badges = get(props.user, 'badges', []);
  const rows = chunk(badges, COLUMNS);

  return (
    <Grid equal={true} columns={COLUMNS} className='user-badges-container'>
      {rows.map((row, idx) => (
        <Grid.Row key={idx}>
          {row.map(badge => (
            <Grid.Column centered={true} className='badge-container' key={badge.id}>
              {badge.unlocked ? <UnlockedBadge {...badge} /> : <LockedBadge {...badge} />}
              <BadgeFooter {...badge} />
            </Grid.Column>
          ))}
        </Grid.Row>
      ))}
    </Grid>
  );
};

export default UserBadgesPage;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/UserBadgesPage.jsx